// extracted by mini-css-extract-plugin
module.exports = {"space":"WebviewCloseButton-space-99cf","button":"WebviewCloseButton-button-99cf"};